import { render, staticRenderFns } from "./LandingHomeFR.vue?vue&type=template&id=464d1d7c&scoped=true"
import script from "./LandingHomeFR.vue?vue&type=script&lang=js"
export * from "./LandingHomeFR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464d1d7c",
  null
  
)

export default component.exports